exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 768px) {\n.search[data-v-492779c9] {\n    margin-top: 42px;\n}\n.toolbarPageBottomBlank[data-v-492779c9] {\n    height: 175px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 996px) {\n.search[data-v-492779c9] {\n    margin-top: 35px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-492779c9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/attachments/CMAttachmentsPage.vue
// module id = 1582
// module chunks = 2